import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/LanguageContext';
import { useCookieConsent } from '../../site/CookieConsent';

const TXT: Record<string, {
  title: string; body: string; policy: string; all: string; reject: string; customize: string;
}> = {
  de: {
    title: 'Wir verwenden Cookies',
    body: 'Wir nutzen technisch notwendige Cookies und – nur mit Ihrer Zustimmung – Cookies für Google Maps und Statistik. Mehr in unserer',
    policy: 'Cookie-Richtlinie',
    all: 'Alle akzeptieren',
    reject: 'Ablehnen',
    customize: 'Einstellungen',
  },
  en: {
    title: 'We use cookies',
    body: 'We use strictly necessary cookies and – only with your consent – cookies for Google Maps and statistics. Learn more in our',
    policy: 'Cookie Policy',
    all: 'Accept all',
    reject: 'Reject',
    customize: 'Customize',
  },
  it: {
    title: 'Utilizziamo i cookie',
    body: 'Usiamo cookie tecnici necessari e – solo con il tuo consenso – cookie per Google Maps e statistiche. Maggiori dettagli nella nostra',
    policy: 'Cookie Policy',
    all: 'Accetta tutti',
    reject: 'Rifiuta',
    customize: 'Personalizza',
  },
};

const CookieBanner: React.FC = () => {
  const { lang } = useI18n();
  const { bannerOpen, acceptAll, rejectAll, openPreferences } = useCookieConsent();
  if (!bannerOpen) return null;
  const c = TXT[lang] || TXT.de;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={c.title}>
      <h4>{c.title}</h4>
      <p>
        {c.body} <Link to="/cookie-policy">{c.policy}</Link>.
      </p>
      <div className="cookie-actions">
        <button type="button" className="cookie-btn primary" onClick={acceptAll}>{c.all}</button>
        <button type="button" className="cookie-btn ghost" onClick={rejectAll}>{c.reject}</button>
        <button type="button" className="cookie-btn ghost" onClick={openPreferences}>{c.customize}</button>
      </div>
    </div>
  );
};

export default CookieBanner;
